'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDataStatus = exports.fetchWithDrawsData = exports.failureWithDraws = exports.receiveWithDraws = exports.FAILURE_WITHDRAWS = exports.RECEIVE_WITHDRAWS = exports.fetchResellersData = exports.failureResellers = exports.receiveResellers = exports.FAILURE_RESELLERS = exports.RECEIVE_RESELLERS = undefined;

var _css = require('antd/lib/notification/style/css');

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECEIVE_RESELLERS = exports.RECEIVE_RESELLERS = 'RECEIVE_RESELLERS'; /**
                                                                          * 客户相关Actions
                                                                          */
var FAILURE_RESELLERS = exports.FAILURE_RESELLERS = 'FAILURE_RESELLERS';

var receiveResellers = exports.receiveResellers = function receiveResellers(response) {

  return {
    type: RECEIVE_RESELLERS,
    data: response.data,
    pagination: response.meta.pagination
  };
};

var failureResellers = exports.failureResellers = function failureResellers(error) {
  return {
    type: FAILURE_RESELLERS,
    error: error
  };
};

var fetchResellersData = exports.fetchResellersData = function fetchResellersData(page) {
  return function (dispatch) {
    return (0, _api.fetchResellers)(page).then(function (response) {
      return dispatch(receiveResellers(response.data));
    }).catch(function (error) {
      _notification2.default['error']({
        message: '获取失败',
        description: error.response && error.response.data && error.response.data.message
      });
      dispatch(failureResellers(error));
    });
  };
};

//提现申请

var RECEIVE_WITHDRAWS = exports.RECEIVE_WITHDRAWS = 'RECEIVE_WITHDRAWS';
var FAILURE_WITHDRAWS = exports.FAILURE_WITHDRAWS = 'FAILURE_WITHDRAWS';

var receiveWithDraws = exports.receiveWithDraws = function receiveWithDraws(response) {

  return {
    type: RECEIVE_WITHDRAWS,
    data: response.data,
    pagination: response.meta.pagination
  };
};

var failureWithDraws = exports.failureWithDraws = function failureWithDraws(error) {
  return {
    type: FAILURE_WITHDRAWS,
    error: error
  };
};

var fetchWithDrawsData = exports.fetchWithDrawsData = function fetchWithDrawsData(page) {
  return function (dispatch) {
    return (0, _api.fetchWithDraws)(page).then(function (response) {
      return dispatch(receiveWithDraws(response.data));
    }).catch(function (error) {
      _notification2.default['error']({
        message: '获取失败',
        description: error.response && error.response.data && error.response.data.message
      });
      dispatch(failureWithDraws(error));
    });
  };
};
//提现完成
var updateDataStatus = exports.updateDataStatus = function updateDataStatus(id) {
  return function (dispatch) {
    return (0, _api.updateWithDrawStatus)(id).then(function (response) {
      return dispatch(fetchWithDrawsData());
    }).catch(function (error) {
      _notification2.default['error']({
        message: '更改失败',
        description: error.response && error.response.data && error.response.data.message
      });
      dispatch(failureWithDraws(error));
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/reseller.js
// module id = 916
// module chunks = 0